const DetectivesSVG = () => {
    return (
        <svg width='418' height='280' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0)'>
                <path fill='#fff' d='M59 40h300v200H59z' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M107.134 236.797h205.519V92H107.134v144.797z'
                    fill='#F2F5F7'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M205.223 232.126h9.342V99.0063h-9.342V232.126z'
                    fill='#CED8E1'
                />
                <path
                    d='M174.863 120.025h-53.715v100.424h32.696M121.147 134.038h53.715'
                    stroke='#CED8E1'
                    strokeWidth='1.2'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M97.7925 178.411h9.3415v-28.025h-9.3415v28.025z'
                    fill='#CED8E1'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M331.336 178.411h-18.683v-28.025h18.683c7.74 0 14.013 6.273 14.013 14.012 0 7.74-6.273 14.013-14.013 14.013z'
                    fill='#F2F5F7'
                />
                <mask id='a' maskUnits='userSpaceOnUse' x='97' y='92' width='249' height='145'>
                    <path d='M97.7925 236.797H345.349V92H97.7925v144.797z' fill='#fff' />
                </mask>
                <g mask='url(#a)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M139.832 225.12h65.391V106.013h-65.391V225.12zM214.564 225.12h65.392V106.013h-65.392V225.12z'
                        fill='#fff'
                    />
                    <path
                        d='M200.552 131.702h18.682M200.552 141.044h18.682M200.552 187.753h18.682M200.552 197.095h18.682'
                        stroke='#371F38'
                        strokeWidth='1.2'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M130.489 211.107h9.341v-65.392h-9.341v65.392z'
                        fill='#90DCF5'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M151.507 126.92h39.703v-9.23h-39.703v9.23zM151.507 143.38h39.703v-9.231h-39.703v9.231zM151.507 159.728h39.703v-9.23h-39.703v9.23zM151.507 176.076h39.703v-9.23h-39.703v9.23zM151.507 192.424h39.703v-9.23h-39.703v9.23zM151.507 208.772h39.703v-9.232h-39.703v9.232zM228.576 126.92h39.703v-9.23h-39.703v9.23zM228.576 143.38h39.703v-9.231h-39.703v9.231zM228.576 159.728h39.703v-9.23h-39.703v9.23zM228.576 176.076h39.703v-9.23h-39.703v9.23zM228.576 192.424h39.703v-9.23h-39.703v9.23zM228.576 208.772h39.703v-9.232h-39.703v9.232z'
                        fill='#F2F5F7'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M333.671 164.399c0 1.289-1.046 2.335-2.335 2.335-1.29 0-2.336-1.046-2.336-2.335 0-1.29 1.046-2.336 2.336-2.336 1.289 0 2.335 1.046 2.335 2.336z'
                        fill='#90DCF5'
                    />
                    <path d='M312.652 150.386v28.025' stroke='#CED8E1' strokeWidth='1.2' />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M297.602 234.808v-6.963h10.899v9.687h-13.624l2.725-2.724z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M316.675 210.286v27.246h-13.623l2.725-2.718v-24.47l10.898-.058z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M316.514 207.268l3.189 24.664h-25.128l3.028-21.495 18.911-3.169z'
                    fill='#119DCB'
                />
                <path
                    d='M327.833 220.449v5.449h-5.449v-5.449h5.449zm-18.164-27.247v5.45h-5.45v-5.45h5.45zM276.694 185.573l4.671 2.807 2.807-4.671-4.671-2.807-2.807 4.671z'
                    fill='#6D2C00'
                />
                <path
                    d='M275.83 181.928l4.671 2.807 1.403-2.336-4.671-2.806-1.403 2.335zM309.825 181.516c-2.452-.522-4.87.696-5.971 2.819l-2.961 4.258 1.783.814c-.05 2.474 1.599 4.722 4.052 5.371l.265.063c2.944.626 5.837-1.253 6.463-4.197l.567-2.665c.625-2.944-1.254-5.838-4.198-6.463z'
                    fill='#6D2C00'
                />
                <path
                    d='M303.684 188.567c-1.472-.313-2.919.627-3.232 2.099l5.331 1.133c.313-1.472-.627-2.919-2.099-3.232zm7.796-3.914c-2.208-.469-4.251.343-4.564 1.815-.114.534.016 1.081.332 1.584.357-.336.864-.497 1.377-.388.828.176 1.357.989 1.181 1.817-.025.115-.061.224-.108.326.207.07.425.129.649.176 1.257.267 2.46.119 3.322-.33l.354-1.674c.121-.569.148-1.136.092-1.686l-.042-.325-.081-.078c-.618-.569-1.493-1.02-2.512-1.237z'
                    fill='#9AA9B8'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M316.675 210.378l-19.072.059s.749-13.624 8.174-13.624c7.424 0 10.898 13.565 10.898 13.565z'
                    fill='#119DCB'
                />
                <path
                    d='M281.903 185.634l23.873 15.267s9.99-1.211 13.883 7.871l5.19 12.975'
                    stroke='#119DCB'
                    strokeWidth='6.3'
                    strokeLinejoin='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M299.523 203.745h10.898v-8.174h-10.898v8.174zM300.596 182.673l3.665-1.191 4.902-3.618 7.283 3.711-.571 3.786 1.191 3.665-16.47-6.353z'
                    fill='#119DCB'
                />
                <path d='M307.697 199.336l-5.449 5.449v24.522' stroke='#371F38' strokeWidth='.933333' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M58.8687 239.911H358.583v-3.892H58.8687v3.892z'
                    fill='#CED8E1'
                />
                <path
                    d='M72.4272 211.541l-3.8536 3.853 3.8536 3.853 3.853-3.853-3.853-3.853zm39.8658-12.024v5.449h7.305v-5.449h-7.305zm-18.7819-9.385v3.027h5.4494v-3.027h-5.4494z'
                    fill='#FA8100'
                />
                <path
                    d='M96.236 177.719c2.5075 0 4.619 1.694 5.254 4l2.012 4.78-1.914.425c-.466 2.431-2.5451 4.287-5.08 4.412l-.272.007c-3.0096 0-5.4494-2.44-5.4494-5.45v-2.724c0-3.01 2.4398-5.45 5.4494-5.45z'
                    fill='#FA8100'
                />
                <path
                    d='M85.3369 194.067v-9.536c0-5.267 4.2696-9.536 9.5364-9.536 5.2667 0 9.5367 4.269 9.5367 9.536v4.087c0 3.01-2.44 5.449-5.4497 5.449l.0013-3.454c1.2594-.729 2.2004-1.948 2.5614-3.396l.065-.293 1.913-.425-2.011-4.78c-.132-.481-.329-.934-.579-1.352l.03-.049c-.853 1.456-2.3616 2.481-4.1205 2.668l-.313.025-.2719.006-.0069.276c-.0101.202-.0312.402-.0628.598-.1085-.025-.2211-.038-.3367-.038-.8465 0-1.5328.686-1.5328 1.533 0 .594.3383 1.109.8328 1.364.7085.74 1.1064 1.726 1.1064 2.756v4.561H85.3369z'
                    fill='#BB5602'
                />
                <path
                    d='M115.111 202.358l-7.198 6.695-10.8986-10.899h-7.6717'
                    stroke='#119DCB'
                    strokeWidth='6.3'
                    strokeLinejoin='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M106.244 183.471l-2.725-2.724-2.724-5.45h-8.1745l-1.211 3.633-2.7246 2.725 17.5591 1.816z'
                    fill='#119DCB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M93.2262 207.632v27.305H106.85l-2.725-2.724v-24.522l-10.8988-.059z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M82.3276 207.632l-10.8987 27.305h13.6234l-1.5137-2.724 9.6877-24.522-10.8987-.059z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M71.4288 229.488H106.85l-2.725-35.421H85.0522l-13.6234 35.421z'
                    fill='#119DCB'
                />
                <path d='M89.1396 198.154l-15.137 15.137' stroke='#119DCB' strokeWidth='6.3' strokeLinejoin='round' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M101.4 196.792H90.5014v-5.449H101.4v5.449z'
                    fill='#119DCB'
                />
                <path d='M95.9508 194.067l5.4492 5.45v24.522' stroke='#371F38' strokeWidth='.933333' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M183.308 172.223c3.676 8.256-1.316 17.735-10.143 19.266l-54.273 9.414 43.312-34.033c7.044-5.536 17.429-2.902 21.104 5.353z'
                    fill='#FECD08'
                />
                <mask id='b' maskUnits='userSpaceOnUse' x='111' y='159' width='78' height='56'>
                    <path d='M177.656 159.528l-66.571 29.639 11.305 25.39 66.57-29.639-11.304-25.39z' fill='#fff' />
                </mask>
                <g mask='url(#b)' fillRule='evenodd' clipRule='evenodd' fill='#371F38'>
                    <path d='M122.697 197.91l-6.442 2.868.965 2.167 6.442-2.868-.965-2.167z' />
                    <path d='M122.697 197.911l3.811-2.995 1.929 4.333-4.775.829-.965-2.167z' />
                </g>
            </g>
            <defs>
                <clipPath id='clip0'>
                    <path fill='#fff' transform='translate(59 40)' d='M0 0h300v200H0z' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default DetectivesSVG;
